export enum Features {
  radar = '@@radar',
  table = '@@table',
  targets = '@@targets',
  webSocket = '@@webSocket',
  virazh = '@@virazh',
  common = '@@common',
}
